<template>
  <div class="desk-flag-add" v-dialog-drag :style="{ bottom: $route.meta.showTabs ? '59px' : '10px' }">
    <div class="desk-flag-btn"  @click="deskHandle">
      <img src="@/assets/images/plat-logo.png" alt="" />
      <span>下载到桌面</span>
    </div>
  </div>
</template>

<script>

export default {
  directives: {
    dialogDrag: {
      bind(el) {
        let isDragging = false;
        let offsetX, offsetY;

        const startDrag = (event) => {
          isDragging = true;
          const touch = event.touches ? event.touches[0] : event;
          offsetX = touch.clientX - el.getBoundingClientRect().left;
          offsetY = touch.clientY - el.getBoundingClientRect().top;

          document.addEventListener("mousemove", onDrag);
          document.addEventListener("mouseup", stopDrag);
          document.addEventListener("touchmove", onDrag);
          document.addEventListener("touchend", stopDrag);
        };

        const onDrag = (event) => {
          if (!isDragging) return;
          const touch = event.touches ? event.touches[0] : event;
          el.style.left = `${touch.clientX - offsetX}px`;
          el.style.top = `${touch.clientY - offsetY}px`;
          // el.style.bottom = "";
        };

        const stopDrag = () => {
          isDragging = false;
          document.removeEventListener("mousemove", onDrag);
          document.removeEventListener("mouseup", stopDrag);
          document.removeEventListener("touchmove", onDrag);
          document.removeEventListener("touchend", stopDrag);
        };

        el.addEventListener("mousedown", startDrag);
        el.addEventListener("touchstart", startDrag);
      },
    },
  },
  methods: {
      
      deskHandle() {
        this.$emit('deskHandle')
      }
  }
};
</script>

<style lang="scss">
.desk-flag-add {
    position: fixed;
    left: 215px;
    z-index: 999;
    cursor: grab;
    touch-action: none;
  .desk-flag-btn {
    width: 319px;
    height: 80px;
    background: #ff7a3e;
    box-shadow: 0px 1px 7px 0px rgba(255, 122, 62, 0.54);
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 49px;
      height: 49px;
      margin-right: 7px;
    }
    span {
      font-family: AlibabaPuHuiTi_2_65_Medium;
      font-size: 27px;
      color: #ffffff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/DeskFlagAdd.vue